module.exports = __webpack_public_path__ + "img/symbol_7.c0d3ecdc.png";